/*
    Create by fanglijuan 2016-05-10
*/
'use strict';
angular.module('sortUsersModule', [])
    .controller('sortUsersCtrl', ['$scope', '$stateParams', '$location', 'trsHttpService', '$modalInstance', '$validation', 'userManageMentService', 'trsspliceString', 'sortUserInfo', function ($scope, $stateParams, $location, trsHttpService, $modalInstance, $validation, userManageMentService, trsspliceString, sortUserInfo) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化参数
         */
        function initStatus() {
            $scope.data = {
                modalTitle: sortUserInfo.modalTitle,
                UserId: sortUserInfo.user.USERID,
                itemcount: sortUserInfo.itemcount,
                GroupId: $location.search().groupid,
                group: '',
                userName: sortUserInfo.user.TRUENAME,
                curPos: sortUserInfo.curPos,
                showInp: false
            };
            $scope.status = {
                sortOptionSelected: []
            };

        }

        /*
        初始化下拉框
         */
        function initDropDown() {
            $scope.status.sortOptions = [{
                name: '最前',
                value: 1
            }, {
                name: '最后',
                value: sortUserInfo.itemcount
            }, {
                name: '指定位置',
                value: ''
            }];
            $scope.status.sortOptionSelected.push($scope.status.sortOptions[0]);
        }

        /**
         * [initData description]初始化数据
         */
        function initData() {
            initDropDown();
            if ($stateParams.groupid != null) {
                queryGroupByGroupId();
            }

        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据(下拉框选择：最前面，最后面，指定位置)
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function (index) {
            if (index == 2) {
                $scope.data.showInp = true;
            } else {
                $scope.data.showInp = false;
            }
            $scope.status.sortOptionSelected = [];
            $scope.status.sortOptionSelected.push($scope.status.sortOptions[index]);
        };
        // 确定
        $scope.confirm = function () {
            $validation.validate($scope.sortUsersSubmitForm).success(function () {
                var params = {
                    'serviceid': 'mlf_usermanagement',
                    'methodname': 'sortSetUpUsers',
                    'FromUserId': $scope.data.UserId,
                    'NewOrder': $scope.status.sortOptionSelected[0].value,
                    'GroupId': $scope.data.GroupId
                };
                if ($stateParams.groupid != null) {
                    params.GroupId = $stateParams.groupid;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $modalInstance.close();
                });
            });
        };
        // 取消
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };

        // 获取组织信息（组织名称）
        function queryGroupByGroupId() {
            var params = {
                'serviceid': 'mlf_groupmanagement',
                'methodname': 'getGroupDetail',
                'GroupId': $scope.data.GroupId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.group = data;
            });
        }
    }]);
